<template>
  <validation-observer
    ref="observer"
  >
    <!-- Form -->
    <b-form
      class="p-2"
      @reset.prevent="resetForm"
    >

      <!-- Offer Name -->
      <validation-provider
        #default="{ errors }"
        name="offerName"
        rules="required"
      >
        <b-form-group
          :label="$t('offer name')"
          label-for="offer-name"
          :onchange="checkUpdate('offerName')"
        >
          <b-form-input
            id="offer-name"
            v-model="form.offerName"
            autofocus
            :state="errors.length > 0 ? false:null"
            trim
            placeholder="20% OFF"
          />

          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Offer Type -->
      <validation-provider
        #default="{ errors }"
        name="OfferType"
        rules=""
      >
        <b-form-group
          :label="$t('offer type')"
          label-for="offer-type"
          :onchange="checkUpdate('offerType')"
        >
          <b-form-radio-group
            id="offerType"
            v-model="form.offerType"
            :options="options"
            class="demo-inline-spacing"
            name="radio-inline"
            :onchange="changeAmount(form.offerType)"
          />
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Discount Amount -->
      <validation-provider
        #default="{ errors }"
        ref="discountAmount"
        :name="$t('discount amount percentage')"
        rules="required|integer"
      >
        <b-form-group
          id="discountAmount"
          :label="$t('discount amount percentage')"
          label-for="discount-amount"
          :state="errors.length > 0 ? false:null"
          :onchange="checkUpdate('discountAmount')"
        >
          <b-input-group
            :prepend="amountPrepend"
            :append="amountAppend"
          >
            <b-form-input
              id="discountAmount"
              v-model.number="form.discountAmount"
              autofocus
              :state="errors.length > 0 ? false:null"
              placeholder="20"
            />
          </b-input-group>

          <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Start Date Time -->
      <validation-provider
        #default="{ errors }"
        name="startDateTime"
        rules=""
      >
        <b-form-group
          :label="$t('start date time')"
          label-for="start-date-time"
        >
          <flat-pickr
            v-model="form.startDateTime"
            class="form-control"
            :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', static: true, time_24hr: true }"
            @onChange="checkUpdate('startDateTime')"
          />

          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- End Date Time -->
      <validation-provider
        #default="{ errors }"
        name="endDateTime"
        rules=""
      >
        <b-form-group
          :label="$t('end date time')"
          label-for="end-date-time"
        >
          <flat-pickr
            v-model="form.endDateTime"
            class="form-control"
            :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', static: true, time_24hr: true }"
            @onChange="checkUpdate('endDateTime')"
          />

          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- maximumTotalUsage -->
      <validation-provider
        #default="{ errors }"
        name="maximumTotalUsage"
        rules="between:0,1000"
      >
        <b-form-group
          :label="`${$t('maximum total usage')} (${$t('zero to thousand')})`"
          label-for="company"
          :onchange="checkUpdate('maximumTotalUsage')"
        >
          <b-form-input
            id="maximumTotalUsage"
            v-model="form.maximumTotalUsage"
            :state="errors.length > 0 ? false:null"
            placeholder="100"
            trim
          />

          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- One Per Customer -->
      <validation-provider
        #default="{ errors }"
        name="perCustomer"
        rules=""
      >
        <b-form-group
          :label="`${$t('limit usage')} (${$t('pay function')})`"
          label-for="per-customer"
          :state="errors.length > 0 ? false:null"
          :onchange="checkUpdate('perCustomer')"
        >
          <b-form-checkbox
            v-model="form.perCustomer"
            value="1"
            :disabled="true"
          >
            {{ $t('one time only') }}
          </b-form-checkbox>
          <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Code -->
      <validation-provider
        #default="{ errors }"
        name="coupon code"
        rules="required"
      >
        <b-form-group
          :label="`${$t('customize coupon code')} (${$t('pay function')})`"
          label-for="coupon-code"
          :onchange="checkUpdate('code')"
        >
          <b-form-input
            id="coupon-code"
            v-model="form.code"
            autofocus
            :state="errors.length > 0 ? false:null"
            trim
            :disabled="true"
          />

          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <!-- Description -->
      <validation-provider
        #default="{ errors }"
        name="description"
        rules="max:50"
      >
        <b-form-group
          :label="$t('description')"
          label-for="description"
          :state="errors.length > 0 ? false:null"
          :onchange="checkUpdate('description')"
        >
          <b-form-textarea
            id="description"
            v-model="form.description"
            placeholder="則扣限制200元低消"
            rows="3"
          />
          <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormRadioGroup, BFormTextarea, BFormCheckbox, BInputGroup,
} from 'bootstrap-vue'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email } from '@validations'
import * as rules from 'vee-validate/dist/rules'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import VoucerCodeGenerator from 'voucher-code-generator'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

export default {
  components: {
    BFormRadioGroup,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormInvalidFeedback,
    BFormTextarea,
    BFormCheckbox,
    flatPickr,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  /* model: {
    prop: 'isAddNewCouponSidebarActive',
    event: 'update:is-add-new-coupon-sidebar-active',
  }, */
  props: {
    userId: {
      type: String,
      required: true,
      default: '',
    },
    campaignList: {
      type: Array,
      default: () => ['*'],
    },
    coupon: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        startDateTime: null,
        endDateTime: null,
        offerName: '',
        offerType: 'percentage',
        maximumTotalUsage: 0,
        perCustomer: 0,
        discountAmount: null,
        codes: [],
        campaigns: ['*'],
        description: '',
      },
      amountPrepend: '',
      amountAppend: '%',
      required,
      alphaNum,
      email,
      options: [
        { text: this.$t('percentage'), value: 'percentage' },
        { text: this.$t('flat'), value: 'flat' },
      ],
    }
  },
  mounted() {
    if (this.coupon) {
      this.form = { ...this.coupon }
    } else {
      this.form.code = this.getCode()
    }
  },
  methods: {
    checkUpdate(type) {
      if (this.form.discountAmount !== null && this.form.discountAmount !== undefined) {
        if (this.form[type] !== this.coupon[type]) {
          let check = true
          Object.entries(this.$refs.observer.errors).forEach(([, value]) => {
            if (value[0]) {
              check = false
            }
          })

          const updateData = {}

          Object.entries(this.form).forEach(([key, value]) => {
            if (this.form[key] !== this.coupon[key]) {
              updateData[key] = value
            }
          })

          this.$emit('ready', check)
          this.$emit('update', updateData)
        } else if (this.form[type] === this.coupon[type]) {
          this.$emit('ready', false)
        }
      }
    },
    resetForm() {
      this.form = {
        startDateTime: null,
        endDateTime: null,
        offerName: '',
        offerType: 'percentage',
        maximumTotalUsage: 0,
        perCustomer: 0,
        discountAmount: null,
        codes: [],
        code: this.getCode(),
        campaigns: ['*'],
        description: '',
      }
      this.$refs.observer.reset()
      this.discountAmountText = 'discount amount'
    },
    getCode: async () => {
      const [code] = await VoucerCodeGenerator.generate({
        length: 8,
        count: 1,
        charset: VoucerCodeGenerator.charset('alphabetic'),
      })
      return code
    },
    changeAmount(selected) {
      if (selected === 'flat') {
        this.amountPrepend = '$'
        this.amountAppend = '.00'
      } else if (selected === 'percentage') {
        this.amountPrepend = ''
        this.amountAppend = '%'
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
